import { Injectable } from '@angular/core';
import { SearchStateService } from './search-state.service';
import { IEventAnalitycs } from '@core/models/analytics';

@Injectable()
export class AnalyticsService {
  private static PRODUCT_TYPE = 'hotel';
  private static EVENT_IMPRESION = 'productView';
  private static EVENT_DETAIL = 'detail';
  private static EVENT_PRODUCT_ADD_TO_CART = 'productAddToCart';

  public mapping: any;

  constructor(public searchStateService: SearchStateService) {
    this.initialSetup();
  }

  public addToCart(params) {
    const event = {
      event: 'addToCart',
      ecommerce: {
        currencyCode: params.currencyCode,
        add: {
          products: [
            {
              id:
                'HTL|' +
                params.cityId +
                '|' +
                params.hotelId +
                '|' +
                this.normalize(params.hotelName),
              name: 'HTL',
              price: params.priceTotal,
              category: 'HTL',
              quantity: 1,
              variant: params.mealplanCode,
            },
          ],
        },
      },
      label: params.label,
    };
    dataLayer.push(event);
  }

  public trackEvent(params) {
    const event = {
      event: params.nonInteraction ? 'trackEventNonInteraction' : 'trackEvent',
      eventCategory: 'HTL|' + params.section,
      eventAction: params.action,
      eventLabel: params.label,
    };
    dataLayer.push(event);
  }

  public trackEventClickTicket(params) {
    const event = {
      event: params.nonInteraction ? 'trackEventNonInteraction' : 'trackEvent',
      eventCategory: 'HTL|' + params.section,
      eventAction: params.action,
      eventLabel: params.label,
      eventValue: params.value,
    };
    dataLayer.push(event);
  }

  public trackPrDetail(params) {
    const event = {
      event: 'trackPrDetail',
      ecommerce: {
        detail: {
          actionField: {
            list: 'HTL|Detail',
          },
          products: [
            {
              name: 'HTL',
              id:
                'HTL|' +
                params.cityId +
                '|' +
                params.hotelId +
                '|' +
                this.normalize(params.hotelName),
              list: 'HTL|Detail',
              category: 'HTL',
              quantity: 1,
            },
          ],
        },
      },
    };
    dataLayer.push(event);
  }

  public productClick(params) {
    const event = {
      event: 'productClick',
      ecommerce: {
        click: {
          actionField: {
            list: 'HTL|Results',
          },
          products: [
            {
              name: 'HTL',
              id:
                'HTL|' +
                params.cityCode +
                '|' +
                params.hotelId +
                '|' +
                this.normalize(params.hotelName),
              price: params.priceTotal,
              list: 'HTL|Results',
              variant: params.mealPlanCode,
              position: params.index,
              category: 'HTL',
              quantity: 1,
            },
          ],
        },
      },
    };
    dataLayer.push(event);
  }

  public trackProductImpressions(params) {
    const mappedHotels = params.hotels.map((hotel, index) => {
      return {
        name: 'HTL',
        id: 'HTL|' + params.entityId + '|' + hotel.id + '|' + this.normalize(hotel.name),
        price: hotel.rate.price.total,
        list: 'HTL|Results',
        variant: hotel.rate.meal_plan.code,
        position: index + 1,
        category: 'HTL',
        quantity: 1,
      };
    });
    const event = {
      ecommerce: {
        currencyCode: params.currencyCode,
        impressions: mappedHotels,
      },
    };
    dataLayer.push(event);
  }

  public newAddToCart(response: any) {
    const product = { ...response };
    this.newTrackEvent(AnalyticsService.EVENT_PRODUCT_ADD_TO_CART, [product]);
  }

  public newTrackProductImpressions(body: any) {
    const { pagination, hotels } = body;
    const query = this.getSelectedFilters(pagination);
    const products = hotels.map((hotel) => ({ ...hotel, query }));
    this.newTrackEvent(AnalyticsService.EVENT_IMPRESION, products);
  }

  public newTrackPrDetail(response: any) {
    const query = this.getSelectedFilters();
    const product = { ...response, query };
    this.newTrackEvent(AnalyticsService.EVENT_DETAIL, [product]);
  }

  /**
   * Get selected filters from user (amenities, passangers, orders, etc)
   * @param pagination Pagination opcional (only results)
   *
   */
  private getSelectedFilters(pagination?) {
    const decodeDate = this.searchStateService.getDecodedDate();
    const sortBy = this.searchStateService.getSortBy();
    const filters: any = {
      startDate: decodeDate.from,
      endDate: decodeDate.to,
      passengers: this.searchStateService.getDecodedRooms().total,
      appliedFilters: this.searchStateService.getDecodedFilters(),
      appliedOrders: sortBy
        ? { sortBy, criteria: this.searchStateService.getSortCriteria() }
        : {},
    };
    if (pagination) {
      filters.offset = pagination.offset;
      filters.limit = pagination.limit;
    }
    return filters;
  }

  /**
   * Send event to Analitycs new documentation
   * @param {string} eventType EVENT_TYPE
   * @param {Object} payload content
   */
  private newTrackEvent(eventType: string, payload: any) {
    const event: IEventAnalitycs = {
      event: eventType,
      productType: AnalyticsService.PRODUCT_TYPE,
      products: payload,
    };
    dataLayer.push(event);
  }

  private normalize(str) {
    let result;
    const ret = [];
    for (let i = 0, j = str.length; i < j; i++) {
      const c = str.charAt(i);
      if (this.mapping.hasOwnProperty(str.charAt(i))) {
        ret.push(this.mapping[c]);
      } else {
        ret.push(c);
      }
    }
    result = ret.join('');
    return encodeURI(result).replace(/%20/g, '+');
  }

  private initialSetup() {
    this.mapping = {};
    const from = 'ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç';
    const to = 'AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuuNnCc';
    for (let i = 0, j = from.length; i < j; i++) {
      this.mapping[from.charAt(i)] = to.charAt(i);
    }
  }
}
